export default function generateBitMask(array) {
    return parseInt(array.map(Number).join(""), 2);
}

export const parseBitMask = (mask, requiredBit) => {
    return !!(mask & requiredBit);
}